import React, { Component } from "react";

import "./index.scss";
import { HOST } from "../../utils/getting";

export default class Navmenu extends Component {
	render() {
		return (
			<ul className="navmenu-component clearfix tac">
				<li className="first-level">
					<a href={HOST} className="first-level-title">首页</a>
					<ul className="first-level-list">
						<li className="second-level">
							<a href="//db.d.163.com/tw/calculator/barbarian.html" className="second-level-title has">常用工具</a>
							<ul className="second-level-list">
								<li className="thrid-level">
									<a href="//db.d.163.com/cn/calculator/barbarian.html" className="thrid-level-title has">技能模拟器</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/cn/calculator/barbarian.html" className="fourth-level-title ">简体中文</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/calculator/barbarian.html" className="fourth-level-title ">繁体中文</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/en/calculator/barbarian.html" className="fourth-level-title ">英文</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href={`${HOST}/html/home/gem-calculator.html`} className="thrid-level-title ">宝石升级查询</a>
								</li>
								<li className="thrid-level">
									<a href={`${HOST}/html/home/kadala.html`} className="thrid-level-title ">赌博模拟器</a>
								</li>
							</ul>
						</li>
						<li className="second-level">
							<a href={`${HOST}/download/`} className="second-level-title ">常用下载</a>
						</li>
					</ul>
				</li>
				<li className="first-level">
					<a href={`${HOST}/html/tutorial/d3basic.html`} className="first-level-title">基础</a>
					<ul className="first-level-list">
						<li className="second-level">
							<a href={`${HOST}/html/tutorial/d3basic.html`} className="second-level-title ">基础介绍</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/characteristic/encounters.html`} className="second-level-title ">游戏特色</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/maps/act1gonglue.html`} className="second-level-title ">游戏攻略</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/maps/d3maps.html`} className="second-level-title ">场景地图</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/history/d3timeline.html`} className="second-level-title ">背景故事</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/development/patchnotes.html`} className="second-level-title ">补丁列表</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/blizzard/basic_blizzard.html`} className="second-level-title ">暴雪相关</a>
						</li>
					</ul>
				</li>
				<li className="first-level">
					<a href={`${HOST}/html/occupations/d3char.html`} className="first-level-title">职业</a>
					<ul className="first-level-list">
						<li className="second-level">
							<a href={`${HOST}/html/occupations/d3barindex.html`} className="second-level-title ">野蛮人</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/occupations/d3dhindex.html`} className="second-level-title ">猎魔人</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/occupations/d3crsindex.html`} className="second-level-title ">圣教军</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/occupations/d3monkindex.html`} className="second-level-title ">武僧</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/occupations/d3wizardindex.html`} className="second-level-title ">魔法师</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/occupations/d3wdindex.html`} className="second-level-title ">巫医</a>
						</li>
						<li className="second-level">
							<a href={`${HOST}/html/occupations/d3necindex.html`} className="second-level-title ">死灵法师</a>
						</li>
					</ul>
				</li>
				<li className="first-level">
					<a href="//wiki.d.163.com/index.php?title=%E9%A6%96%E9%A1%B5" className="first-level-title">百科</a>
				</li>
				<li className="first-level">
					<a href={`${HOST}/video/`} className="first-level-title">视频</a>
				</li>
				{/* <li className="first-level">
					<a href="//hero.d.163.com/" className="first-level-title">天梯榜</a>
				</li> */}
				<li className="first-level">
					<a href="//d.163.com/db/cn" className="first-level-title">数据库</a>
					{/**
					<ul className="first-level-list">
						<li className="second-level">
							<a href="//db.d.163.com/tw/base/legendary" className="second-level-title has">基础</a>
							<ul className="second-level-list">
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/base/legendary" className="thrid-level-title ">传奇物品</a>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/base/suit" className="thrid-level-title ">套装物品</a>
								</li>
							</ul>
						</li>
						<li className="second-level">
							<a href="//db.d.163.com/skill/barbarian/active" className="second-level-title has">技能</a>
							<ul className="second-level-list">
								<li className="thrid-level">
									<a href="//db.d.163.com/skill/barbarian/active" className="thrid-level-title has">野蛮人</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/barbarian/active" className="fourth-level-title ">主动技能</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/skill/barbarian/passive" className="fourth-level-title ">被动技能</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/skill/demon-hunter/active" className="thrid-level-title has">猎魔人</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/demon-hunter/active" className="fourth-level-title ">主动技能</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/demon-hunter/passive" className="fourth-level-title ">被动技能</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/skill/crusader/active" className="thrid-level-title has">圣教军</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/skill/crusader/active" className="fourth-level-title ">主动技能</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/skill/crusader/passive" className="fourth-level-title ">被动技能</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/skill/monk/active" className="thrid-level-title has">武僧</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/monk/active" className="fourth-level-title ">主动技能</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/monk/passive" className="fourth-level-title ">被动技能</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/skill/wizard/active" className="thrid-level-title has">魔法师</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/wizard/active" className="fourth-level-title ">主动技能</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/wizard/passive" className="fourth-level-title ">被动技能</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/skill/witch-doctor/active" className="thrid-level-title has">巫医</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/witch-doctor/active" className="fourth-level-title ">主动技能</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/skill/witch-doctor/passive" className="fourth-level-title ">被动技能</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/cn/skill/necromancer/active" className="thrid-level-title has">死灵法师</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/cn/skill/necromancer/active" className="fourth-level-title ">主动技能</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/cn/skill/necromancer/passive" className="fourth-level-title ">被动技能</a>
										</li>
									</ul>
								</li>
							</ul>
						</li>
						<li className="second-level">
							<a href="//db.d.163.com/item/helm" className="second-level-title has">护甲</a>
							<ul className="second-level-list">
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/helm" className="thrid-level-title has">头部</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/helm/" className="fourth-level-title ">头盔</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/spirit-stone/" className="fourth-level-title ">炼气石</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/voodoo-mask/" className="fourth-level-title ">巫毒面具</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/wizard-hat/" className="fourth-level-title ">秘术帽</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/pauldrons" className="thrid-level-title has">肩膀</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/pauldrons/" className="fourth-level-title ">护肩</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/chest-armor" className="thrid-level-title has">身躯</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/chest-armor/" className="fourth-level-title ">胸甲</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/cloak/" className="fourth-level-title ">斗篷</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/bracers" className="thrid-level-title has">手腕</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/bracers/" className="fourth-level-title ">护腕</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/gloves" className="thrid-level-title has">手掌</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/gloves/" className="fourth-level-title ">手套</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/belt" className="thrid-level-title has">腰部</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/belt/" className="fourth-level-title ">腰带</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/mighty-belt/" className="fourth-level-title ">重型腰带</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/pants" className="thrid-level-title has">腿部</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/pants/" className="fourth-level-title ">裤子</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/boots" className="thrid-level-title has">脚部</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/boots/" className="fourth-level-title ">鞋子</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/amulet" className="thrid-level-title has">珠宝</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/amulet/" className="fourth-level-title ">护身符</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/ring/" className="fourth-level-title ">戒指</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/shield" className="thrid-level-title has">副手</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/shield/" className="fourth-level-title ">盾</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/mojo/" className="fourth-level-title ">咒物</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/orb/" className="fourth-level-title ">法器</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/quiver/" className="fourth-level-title ">箭筒</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/enchantress-focus" className="thrid-level-title has">追随者</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/enchantress-focus/" className="fourth-level-title ">巫女法器</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/scoundrel-token/" className="fourth-level-title ">盗贼道具</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/templar-relic/" className="fourth-level-title ">骑士圣物</a>
										</li>
									</ul>
								</li>
							</ul>
						</li>
						<li className="second-level">
							<a href="//db.d.163.com/item/axe-1h" className="second-level-title has">武器</a>
							<ul className="second-level-list">
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/axe-1h" className="thrid-level-title has">单手</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/axe-1h/" className="fourth-level-title ">斧</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/dagger/" className="fourth-level-title ">匕首</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/mace-1h/" className="fourth-level-title ">钉锤</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/spear/" className="fourth-level-title ">矛</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/sword-1h/" className="fourth-level-title ">剑</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/ceremonial-knife/" className="fourth-level-title ">祭祀刀</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/fist-weapon/" className="fourth-level-title ">拳套武器</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/mighty-weapon-1h/" className="fourth-level-title ">重型武器</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/flail1-1h/" className="fourth-level-title ">连枷</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/axe-2h" className="thrid-level-title has">双手</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/axe-2h/" className="fourth-level-title ">斧</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/mace-2h/" className="fourth-level-title ">钉锤</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/polearm/" className="fourth-level-title ">长柄武器</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/staff/" className="fourth-level-title ">法杖</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/sword-2h/" className="fourth-level-title ">剑</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/daibo/" className="fourth-level-title ">武杖</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/mighty-weapon-2h/" className="fourth-level-title ">重型武器</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/flail2-2h/" className="fourth-level-title ">连枷</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/bow" className="thrid-level-title has">远程</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/bow/" className="fourth-level-title ">弓</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/crossbow/" className="fourth-level-title ">弩</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/hand-crossbow/" className="fourth-level-title ">弩枪</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/wand/" className="fourth-level-title ">魔杖</a>
										</li>
									</ul>
								</li>
							</ul>
						</li>
						<li className="second-level">
							<a href="//db.d.163.com/item/potion" className="second-level-title has">其他</a>
							<ul className="second-level-list">
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/potion" className="thrid-level-title has">消耗品</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/potion/" className="fourth-level-title ">药水</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/addsocket/" className="fourth-level-title ">打孔</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/tome" className="thrid-level-title has">制作</a>
									<ul className="thrid-level-list">
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/tome/" className="fourth-level-title ">锻炼书页</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/blacksmith-plan/" className="fourth-level-title ">铁匠设计图</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/jeweler-design/" className="fourth-level-title ">珠宝匠设计图</a>
										</li>
										<li className="fourth-level">
											<a href="//db.d.163.com/tw/item/crafting-material/" className="fourth-level-title ">制作材料</a>
										</li>
									</ul>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/dye" className="thrid-level-title ">染料</a>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/gem" className="thrid-level-title ">宝石</a>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/quest" className="thrid-level-title ">任务</a>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/tw/item/misc" className="thrid-level-title ">杂项</a>
								</li>
							</ul>
						</li>
						<li className="second-level">
							<a href="//db.d.163.com/artisan/blacksmith/recipe" className="second-level-title has">工匠</a>
							<ul className="second-level-list">
								<li className="thrid-level">
									<a href="//db.d.163.com/artisan/blacksmith/recipe" className="thrid-level-title ">铁匠</a>
								</li>
								<li className="thrid-level">
									<a href="//db.d.163.com/artisan/jeweler/recipe" className="thrid-level-title ">珠宝匠</a>
								</li>
							</ul>
						</li>
					</ul>
					**/}
				</li>
				<li className="first-level">
					<a href="//wiki.d.163.com/diablo" className="first-level-title">经典回顾</a>
				</li>
				<li className="first-level">
					<a href="//bbs.d.163.com" className="first-level-title">论坛</a>
				</li>
				<li class="first-level">
					<a href="https://dd.163.com?utm_source=d163site" class="first-level-title">
						网易DD平台
					</a>
				</li>
			</ul>
		);
	}
}